import React from "react";

const stepLabels = ["Select Items", "Summary", "Review & Place"];

const OrderStepper = ({ step, isStepComplete, setStep }) => {
  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      {stepLabels.map((label, i) => {
        const idx = i + 1;
        const done = isStepComplete(idx);
        const active = idx === step;
        const disabled = !done && !active;
        return (
          <React.Fragment key={label}>
            {i > 0 && (
              <div className="text-muted" style={{ fontSize: "12px" }}>›</div>
            )}
            <div
              className={`d-flex align-items-center gap-1 px-2 py-1 rounded ${
                done || active
                  ? ""
                  : "bg-light text-muted"
              }`}
              style={{
                fontSize: "13px",
                cursor: done ? "pointer" : "default",
                opacity: disabled ? 0.5 : 1,
                backgroundColor: done || active ? "#252525" : undefined,
                color: done || active ? "#fce100" : undefined,
              }}
              onClick={() => done && setStep(idx)}
            >
              {done ? "✓" : idx}
              <span className="d-none d-sm-inline">{label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default OrderStepper;
